import { twMerge } from 'tailwind-merge'

/**
 * Opaque fill for floating chrome that is not a control (the busy pill, cards):
 * these float over scrolling content, so any translucency lets text bleed through.
 */
export const FLOATING_SURFACE_STYLE = {
  background:
    'linear-gradient(var(--background), var(--background)) padding-box, linear-gradient(to bottom, oklch(from var(--background) l c h / 40%), oklch(from var(--background) l c h / 10%)) border-box',
} as const

/**
 * Hover fill for floating chrome that carries text (the footer's CTA pills).
 * Visually the same 5% wash the icon buttons get, but pre-blended into the surface:
 * a translucent `bg-element` would let scrolling content show through the
 * label, and the pill's own text can't be lifted above an overlay.
 */
export const FLOATING_HOVER_FILL_CLASS = 'hover:bg-[color-mix(in_srgb,var(--foreground)_5%,var(--background))]'

/**
 * Opaque `bg-danger/10` for the error chrome a footer grows on a failed invoke,
 * the banner and the Retry pill. A `/10` fill is a wash over whatever sits
 * behind it, and behind the floating bar that is scrolling chat. Pre-blending
 * the same 10% into the background gives the same color with nothing reading
 * through it (HIG-6220).
 */
export const FLOATING_DANGER_SURFACE_CLASS = 'bg-[color-mix(in_srgb,var(--danger)_10%,var(--background))]'

/** Hover step for the above, matching `danger`'s 10% -> 20% lift. */
export const FLOATING_DANGER_HOVER_FILL_CLASS = 'hover:bg-[color-mix(in_srgb,var(--danger)_20%,var(--background))]'

/** Hairline edge so floating chrome reads on light-on-light surfaces. */
export const FLOATING_EDGE_CLASS = 'border'

/** The lift for floating cards. Controls stay flat, like any other Button. */
export const FLOATING_SURFACE_BORDER_CLASS = 'shadow-lg'

/**
 * Button's md box: 28px tall, the corner half that, squircled. For
 * floating chrome that is not itself a `Button` (the busy pill), so it still matches one.
 */
export const FLOATING_SHAPE_CLASS = 'corner-squircle rounded-[var(--radius-size-md)]'

/**
 * The fill for a `Button` that floats over the scrolling thread: opaque, because
 * any translucency lets text bleed through the control, and its hover pre-blended
 * for the same reason. Disabled holds the fill too, where `outline` goes clear.
 */
export const FLOATING_FILL_CLASS = twMerge('bg-background data-[disabled]:bg-background', FLOATING_HOVER_FILL_CLASS)

/** `FLOATING_FILL_CLASS` in the error register, for a `tone="danger"` Button. */
export const FLOATING_DANGER_FILL_CLASS = twMerge(
  FLOATING_DANGER_SURFACE_CLASS,
  'data-[disabled]:bg-[color-mix(in_srgb,var(--danger)_10%,var(--background))]',
  FLOATING_DANGER_HOVER_FILL_CLASS,
)
